// extracted by mini-css-extract-plugin
export default {"select":"SelectUI_select__PmJ-o","fullWidth":"SelectUI_fullWidth__zGaOr"};